import { Color } from '@diritto/common/style/color';
import { NewIconProps } from '@diritto/common/style/icon';
import React from 'react';
import { twMerge } from 'tailwind-merge';

export const LockIcon = ({ className, color = Color.Gray400 }: NewIconProps) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={twMerge('size-[16px]', className)}>
    <g clipPath="url(#clip0_23_4167)">
      <path
        d="M3.81667 15.55C3.38333 15.55 3.01389 15.3972 2.70833 15.0916C2.40278 14.7861 2.25 14.4166 2.25 13.9833V7.04998C2.25 6.61665 2.40278 6.24442 2.70833 5.93331C3.01389 5.6222 3.38333 5.46665 3.81667 5.46665H4.65V4.23331C4.65 3.28887 4.975 2.48609 5.625 1.82498C6.275 1.16387 7.06667 0.833313 8 0.833313C8.93333 0.833313 9.725 1.16387 10.375 1.82498C11.025 2.48609 11.35 3.28887 11.35 4.23331V5.46665H12.1833C12.6167 5.46665 12.9889 5.6222 13.3 5.93331C13.6111 6.24442 13.7667 6.61665 13.7667 7.04998V13.9833C13.7667 14.4166 13.6111 14.7861 13.3 15.0916C12.9889 15.3972 12.6167 15.55 12.1833 15.55H3.81667ZM3.81667 13.9833H12.1833V7.04998H3.81667V13.9833V13.9833ZM8 11.8C8.35556 11.8 8.65833 11.6778 8.90833 11.4333C9.15833 11.1889 9.28333 10.8944 9.28333 10.55C9.28333 10.2166 9.15833 9.91387 8.90833 9.64165C8.65833 9.36942 8.35556 9.23331 8 9.23331C7.64444 9.23331 7.34167 9.36942 7.09167 9.64165C6.84167 9.91387 6.71667 10.2166 6.71667 10.55C6.71667 10.8944 6.84167 11.1889 7.09167 11.4333C7.34167 11.6778 7.64444 11.8 8 11.8ZM6.21667 5.46665H9.78333V4.23331C9.78333 3.71109 9.61389 3.27776 9.275 2.93331C8.93611 2.58887 8.51111 2.41665 8 2.41665C7.5 2.41665 7.07778 2.58887 6.73333 2.93331C6.38889 3.27776 6.21667 3.71109 6.21667 4.23331V5.46665ZM3.81667 13.9833V7.04998V13.9833Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_23_4167">
        <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);
